// extracted by mini-css-extract-plugin
var _1 = "NameRow_dot__be744";
var _2 = "NameRow_read__e3ded";
var _3 = "NameRow_root__f0c14";
export { _1 as "dot", _2 as "read", _3 as "root" }
